module.exports = __webpack_public_path__ + "1-15.png?51429d7a9397cbda363c774499c3b917";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1-15.png
// module id = 92
// module chunks = 0